<template>
  <v-container fluid>
    <div id="app ">
      <v-row>
        <v-col cols="11">
          <Breadcrumb class="row justify-content-center mt-4" />
        </v-col>
        <v-col cols="1" v-if="showLoader">
          <LoaderProgress></LoaderProgress>
        </v-col>
      </v-row>
    </div>

    <v-row class="mt-0 border-bottom">
      <v-col>
        <newcompoent
          style="margin-right: 5px !important"
          :filter_data="param"
        />
      </v-col>
    </v-row>
    <div>
      <tableComponent v-bind:tabledataProp="TableData" v-if="show" />
    </div>
  </v-container>
</template>
<script>
import tableComponent from "../components/tableComponent.vue";
import newcompoent from "../components/newFiltercomp.vue";
import Breadcrumb from "../components/breadcrumbs.vue";
import LoaderProgress from "../components/progressLoader";
import axios from "axios";
import router from "../router";

export default {
  components: { newcompoent, Breadcrumb, LoaderProgress, tableComponent },

  data() {
    return {
      userSelected_Id: null,

      show: false,
      param: {
        machine: false,
        time_period: true,
        check: false,
        aggfunc: false,
        date: new Date().toISOString().slice(0, 10),
        date_2: new Date().toISOString().slice(0, 10),
        redirectStartDate: null,
        redirectEndDate: null,
        redirectPath: null,
        machine_id: null,
        // redirectStartTime:null,
        // redirectEndTime:null
        grpshw: null,
        dateFunc: null,
        checkbox: null,
      },
      TableData: {},
      audit_data: [],
      select_audit: "",
      start_date: null,
      end_date: null,
      showWarning: false,
      showLoader: false,
      dataDownload: [],
      search: "",
      menu: false,
      operatorsData: [],
      headersData: [],
      pagination: {
        page: null,
        itemsPerPage: null,
        pageStart: null,
        pageStop: null,
        pageCount: null,
        itemsLength: null,
      },
    };
  },

  methods: {
    intervalFetchData: function(
      audit_id,
      startDate,
      endDate,
      grpshw,
      dateFunc,
      checkbox,
      userSelected_Id
    ) {
      this.machine_id_Selected = audit_id;
      console.log("aduit dataa chgvgwv", audit_id);
      this.audit_id = audit_id;
      this.start_date = startDate;
      this.end_date = endDate;
      this.grpshw = grpshw;
      this.dateFunc = dateFunc;
      this.checkbox = checkbox;
      this.userSelected_Id = userSelected_Id;
      console.log("machine id", audit_id);
      console.log(
        "selected start date",
        startDate,
        "selected end date",
        startDate
      );
      this.searchNew(
        this.machine_id_Selected,
        startDate,
        endDate,
        this.userSelected_Id
      );
    },

    searchNew: function(machine_id, startDate, endDate,userSelected_Id) {
      this.show = false;
      this.userSelected_Id = userSelected_Id;

      this.start_date = startDate;
      this.end_date = endDate;
      this.machine_id_Selected = machine_id;

      console.log(
        "machine select",
        this.machine_id_Selected,
        "Done to say",
        machine_id
      );
      let params = "";
      if (this.start_date == "") {
        params = ``;
      } else {
        params = `?user_id=${this.userSelected_Id}&startdate=${this.start_date}&enddate=${this.end_date}`;
      }
      let config = {
        method: "get",
        url: `${this.$config.backend_url}/getconsolidatedOverallAudit${params}`,
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("token")}`,
        },
      };
      this.setGridData(config);
    },
    setGridData: function(config) {
      this.showLoader = true;
      this.showWarning = false;
      this.noteLastAPICallTime();
      axios(config)
        .then((response) => {
          console.log("data for audit", response.data);
          // search:'',
          // savingFilename:'AuditData',
          this.TableData["savingFilename"] = "AuditData";
          this.TableData["search"] = "";

          this.TableData["pagination"] = {
            page: null,
            itemsPerPage: null,
            pageStart: null,
            pageStop: null,
            pageCount: null,
            itemsLength: null,
          };
          let tempRow = [];
          let columnHeaders = [];
          let b = response.data.coulmn_name;
          console.log("saikrishna", response.data);
          for (let i = 0; i < response.data.coulmn_name.length; i++) {
            columnHeaders.push(b[i]);
            console.log("typeof(b[i])", typeof b[i]);
            tempRow.push(b[i]);
          }
          this.TableData["columnHeaders"] = columnHeaders;
          this.TableData["tempRow"] = tempRow;

          console.log("prinitng b", this.TableData);
          let empty_object = [];
          for (let i = 0; i < b.length; i++) {
            empty_object.push({ value: b[i], text: b[i], sortable: true });
          }
          console.log("printing empty obj==>", empty_object);
          this.headersData = empty_object;
          this.TableData["headersData"] = this.headersData;
          console.log("this.headersDatathis.headersData", this.headersData);
          // let result = [];
          // for (let i in response.data) result.push([i, response.data[i]]);
          console.log("checking result data=>", response.data.data);
          this.dataDownload = response.data.data;
          this.TableData["dataDownload"] = this.dataDownload || [];

          this.operatorsData = response.data.data;
          this.TableData["operatorsData"] = this.operatorsData || [];

          this.showLoader = false;
          this.show = true;
        })
        .catch((error) => {
          this.showLoader = false;
          if (error.response && error.response.status === 401) {
            sessionStorage.clear();
            router.push("/login");
          } else {
            this.showWarning = true;
            this.item = [];
            console.log("axios error", error.message);
          }
        });
    },
  },
};
</script>
<style scoped>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
